import { change } from 'redux-form';

import { INFERENTIAL_STATISTICS as FORM } from '../../names';

// Setters

export const setSampleMeanFirst = sampleMean =>
  change(FORM, 'twoSampleT.sampleMeanFirst', sampleMean);

export const setStandardDeviationFirst = standardDeviation =>
  change(FORM, 'twoSampleT.standardDeviationFirst', standardDeviation);

export const setSampleSizeFirst = sampleSize =>
  change(FORM, 'twoSampleT.sampleSizeFirst', sampleSize);

export const setSampleMeanSecond = sampleMean =>
  change(FORM, 'twoSampleT.sampleMeanSecond', sampleMean);

export const setStandardDeviationSecond = standardDeviation =>
  change(FORM, 'twoSampleT.standardDeviationSecond', standardDeviation);

export const setSampleSizeSecond = sampleSize =>
  change(FORM, 'twoSampleT.sampleSizeSecond', sampleSize);

export const setNumericalRowDataSetFirst = name =>
  change(FORM, 'twoSampleT.firstVariable', name);

export const setNumericalRowDataSetSecond = name =>
  change(FORM, 'twoSampleT.secondVariable', name);

